import {ComponentType, Fragment, useContext} from 'react';
import ButtonModuleV4 from './ButtonModuleV4';
import CommentModuleV4 from './CommentModuleV4';
import EventLineV4 from './EventLineV4';
import EventModuleV4 from './EventModuleV4';
import ImageModuleV4 from './ImageModuleV4';
import MissionAttendanceModuleV4 from './MissionModule/MissionAttendanceModuleV4';
import MissionContentBookingModuleV4 from './MissionModule/MissionContentBookingModuleV4';
import MissionPreRequestModuleV4 from './MissionModule/MissionPreRequestModuleV4';
import MissionQuizModuleV4 from './MissionModule/MissionQuizModuleV4';
import RecommendModuleV4 from './RecommendModuleV4';
import ShareModuleV4 from './ShareModuleV4';
import UnionModuleV4 from './UnionModuleV4';
import VideoModuleV4 from './VideoModuleV4';
import {IsUnionModuleContext} from '../../event/common';
import {IModuleListTypeV4, IModuleListV4} from '../type';

interface IProps {
  moduleList: IModuleListV4;
  showBetweenLine?: boolean;
  className?: string;
}

export default function ModuleListV4({
  moduleList,
  showBetweenLine,
  className,
}: IProps) {
  const isUnionModule = useContext(IsUnionModuleContext);

  if (moduleList.length === 0) {
    return null;
  }

  let prevModuleType = moduleList[0].moduleType;
  return (
    <div className={cn('flex flex-col', className)}>
      {moduleList.map((moduleItem, index) => {
        const {moduleType} = moduleItem;
        const ModuleComponent = MODULE_MAP[moduleType];
        const isSameModule = prevModuleType === moduleType;
        prevModuleType = moduleType;
        return (
          <Fragment key={index}>
            {showBetweenLine && index > 0 && (
              <EventLineV4 className="my-40 opacity-30" hasMaxWidth />
            )}
            {!showBetweenLine && index > 0 && (
              <div
                className={cn({
                  'mt-10':
                    isSameModule && !(isUnionModule && moduleType === 'image'), // 조합 모듈 중 이미지 모듈이 연속될 경우엔 gap 을 제거해달라 함
                  'mt-32': !isSameModule,
                })}
              />
            )}
            {moduleItem && <ModuleComponent data={moduleItem} />}
          </Fragment>
        );
      })}
    </div>
  );
}

const MODULE_MAP: {
  [key in IModuleListTypeV4]: ComponentType<{
    data: any;
  }>;
} = {
  missionAttendance: MissionAttendanceModuleV4,
  missionPreRequest: MissionPreRequestModuleV4,
  missionContentBooking: MissionContentBookingModuleV4,
  missionQuiz: MissionQuizModuleV4,
  image: ImageModuleV4,
  video: VideoModuleV4,
  button: ButtonModuleV4,
  union: UnionModuleV4,
  event: EventModuleV4,
  share: ShareModuleV4,
  comment: CommentModuleV4,
  recommend: RecommendModuleV4,
};
